import $ from 'jquery';
import { Drilldown, DropdownMenu, Tooltip } from 'foundation-sites';

// ### Dropdown Main Menu
// Settings
const dropDownEL = $('.js-menu');
const dropDownConcessionaireEL = $('.js-menu-concessionnaire');
const dropDownOptions = {
  closingTime: 100,
};

// Init
const dropDownInstance = new DropdownMenu(dropDownEL, dropDownOptions);
const dropDownConcessionnaireInstance = new DropdownMenu(dropDownConcessionaireEL, dropDownOptions);

// ### DrillDown Mobile Menu
// Settings
const drillDownEl = $(".js-responsive-menu");
const drillDownBack = drillDownEl.attr('data-back');
const triggersMenu = $('.js-responsive-menu-toggle');
const closeMenu = $('.js-responsive-menu-close');
const drillDownOptions = {
  backButton: `<li class="js-drilldown-back"><a class="drilldown__link drilldown__link--back button--back" tabindex="0"><span class="arrow"></span></a></li>`,
  closeOnClick: true,
  parentLink: true,
  autoHeight: true,
  animateHeight: true
};

// Init
const drillDownInstance = new Drilldown(drillDownEl, drillDownOptions);

// ### Toggle Open/Close
triggersMenu.on('click', function(ev){
  ev.preventDefault();
  $('body').toggleClass('nav-open');
});

// ### Close
closeMenu.on('click', function(ev){
  ev.preventDefault();
  $('body').removeClass('nav-open');
});

window.addEventListener('load', function() {
  // Dealer Tooltip
  const tooltip = $('.js-dealer-tooltip');
  if (tooltip.length) {
    const tooltipOptions = {
      showOn: 'large',
      position: 'bottom',
      alignment: 'right',
      clickOpen: false,
    };
    const tooltipEl = new Tooltip(tooltip, tooltipOptions);
  }
});

